module.exports = __webpack_public_path__ + "img/cdbl.13ba00fd.png";